// src/services/authServices.js
import httpServices from './httpServices';
import { Url } from './http';

const apiUrl = Url.baseUrl;

const tokenKey = 'token';
const tokenExpire = 'token_expire';

// Get token from localStorage
export function getBearerToken() {
    return localStorage.getItem(tokenKey);
}

// Apply token globally when app loads
httpServices.setAccessToken(getBearerToken());

// LOGIN
export async function login(username, password) {
    const data = {
        code: username,
        password: password
    };

    const response = await httpServices.post(apiUrl + '/Login', data);
    const token = response.data;

    // save token
    localStorage.setItem(tokenKey, token.token);
    localStorage.setItem(tokenExpire, token['.expires']);

    // update axios token
    httpServices.setAccessToken(token.token);

    return token;
}

// LOGOUT
export function logout() {
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(tokenExpire);

    httpServices.setAccessToken(null);
}

// CHECK
export function isAuthenticated() {
    return !!getBearerToken();
}

// CHANGE PASSWORD
export function changePassword(currentPassword, newPassword) {
    const params = new URLSearchParams({
        CurrentPassword: currentPassword,
        NewPassword: newPassword,
    });
    return httpServices.get(`${apiUrl}/Users/ChangePassword?${params.toString()}`);
}

export default {
    login,
    logout,
    getBearerToken,
    isAuthenticated,
    changePassword
};
